import { LabelAndValue } from "../../components/form";
import { hasProjectRescheduleReason } from "./ambassador-slot-selection/meeting-reschedule-drawer/utils";

type MeetingRescheduleReasonSectionProps = {
  rescheduleReasonType?: string;
  rescheduleReason?: string;
};

export function MeetingRescheduleReasonSection({
  rescheduleReasonType,
  rescheduleReason,
}: MeetingRescheduleReasonSectionProps) {
  if (
    !hasProjectRescheduleReason({ rescheduleReasonType, rescheduleReason })
  ) {
    return null;
  }

  const reasonText = rescheduleReason?.trim();

  if (!reasonText) {
    return null;
  }

  return <LabelAndValue label="Reschedule reason" value={reasonText} />;
}
